export const CATEGORY_TAG_COLOR = 'blue';
export const TAG_CHIP_COLOR = 'cyan';
